import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PROCEDURES_EMAILS_VIEW', {
  TITLE: 'Procedures emails',
  SEND_EMAILS: 'Send emails',
  PROCEDURE_NAME: 'Procedure name',
  EMAIL: 'Email',
  ACTIONS: 'Actions',
  RESEND: 'Resend',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PROCEDURES_EMAILS_VIEW', {
  TITLE: 'Emails de trámites',
  SEND_EMAILS: 'Enviar emails',
  PROCEDURE_NAME: 'Nombre del trámite',
  EMAIL: 'Email',
  ACTIONS: 'Acciones',
  RESEND: 'Reenviar',
});
